module.exports = __webpack_public_path__ + "media/images/prizes__prizeFg--7-9e19df5bbfac60d674a2801d5592f739.png";